/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ----------------------------------------------------------
   1) GOODIE KONFIGURATION AUS DEM DOM HOLEN
      (ALLE .goodie-values ALS ARRAY)
----------------------------------------------------------- */
function getGoodieConfigs() {
  const goodieEls = document.querySelectorAll('.goodie-values');
  if (!goodieEls.length) return [];

  return Array.from(goodieEls).map((el) => ({
    productTitle: el.dataset.productTitle,
    variantId: parseInt(el.dataset.variantId, 10),
    threshold: parseInt(el.dataset.goodieThreshold, 10) // z.B. 8000 (80 € in Cent)
  }));
}


/* ----------------------------------------------------------
   2) CART ABRUFEN
----------------------------------------------------------- */
async function fetchCart() {
  const response = await fetch('/cart.js');
  return await response.json();
}


/* ----------------------------------------------------------
   3) GOODIE HINZUFÜGEN
----------------------------------------------------------- */
async function addGoodieToCart(variantId) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  });

  return await response.json();
}


/* ----------------------------------------------------------
   4) GOODIE ENTFERNEN
----------------------------------------------------------- */
async function removeGoodieFromCart(lineItemKey) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: lineItemKey,
      quantity: 0
    })
  });

  setTimeout(() => {
          document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        )}, 500);
}

/* ----------------------------------------------------------
   5) GOODIE-LOGIK:
      - Threshold auf Warenkorb OHNE jeweiliges Goodie prüfen
      - Goodies hinzufügen / entfernen
----------------------------------------------------------- */
async function checkAndSyncGoodie() {
  const goodies = getGoodieConfigs();
  if (!goodies.length) return;

  const cart = await fetchCart();
  if (!cart || !cart.items) return;

  for (const goodie of goodies) {
    // 1) Prüfen, ob dieses Goodie im Cart ist
    const goodieItem = cart.items.find(
      (item) => item.variant_id === goodie.variantId
    );

    // 2) Warenkorbwert OHNE dieses Goodie berechnen
    const subtotalWithoutThisGoodie = cart.items.reduce((sum, item) => {
      if (item.variant_id === goodie.variantId) {
        return sum; // dieses Goodie ignorieren
      }
      return sum + (item.line_price || 0);
    }, 0);

    const threshold = goodie.threshold; // z.B. 8000 in Cent

    // 3) Fall A: Threshold erreicht/überschritten → Goodie soll drin sein
    if (subtotalWithoutThisGoodie >= threshold) {
      if (!goodieItem) {
        await addGoodieToCart(goodie.variantId);

        setTimeout(() => {
          document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        )}, 200);

      
      }
      // weiter mit nächstem Goodie
      continue;
    }

    // 4) Fall B: Threshold unterschritten → Goodie soll raus
    if (subtotalWithoutThisGoodie < threshold && goodieItem) {
      await removeGoodieFromCart(goodieItem.key);
    }
  }
}

/* ----------------------------------------------------------
   6) LISTENER: BEI JEDER WARENKORBÄNDERUNG PRÜFEN
----------------------------------------------------------- */
document.addEventListener('product:added', async () => {
  await checkAndSyncGoodie();
});

document.addEventListener('cart:change', async () => {
  await checkAndSyncGoodie();
});






